import ptBrIssuer from './issuer/pt-br';
import enUsIssuer from './issuer/en-us';

export default {
  'pt-BR': ptBrIssuer,
  'en-US': enUsIssuer,
};
